import React, { useState } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/styles';
import {
  Button,
  Dialog,
  Typography,
  colors,
  TextField,
  IconButton,
  useMediaQuery
} from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import CloseIcon from '@material-ui/icons/Close';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import Classes from 'services/classes';

const useStyles = makeStyles(theme => ({
  root: {},
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(1, 0)
  },
  actions: {
    backgroundColor: colors.grey[100],
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between'
  },
  startButton: {
    color: theme.palette.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900]
    }
  },
  inputPadding: {
    padding: theme.spacing(0, 1)
  },
  description: {
    flexGrow: 1,
    alignItems: 'flex-start'
  }
}));

const initValues = { name: '', description: '', code: '', expirationDate: moment().add(6, 'month') }

const Modal = props => {
  const { open, onClose, onCreateGroup, className } = props;
  const theme = useTheme();
  const classes = useStyles();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [values, setValues] = useState(initValues);

  const handleChange = (name) => ({ target }) => {
    setValues(values => ({ ...values, [name]: target.value }))
  }

  const handleClose = () => {
    onClose();
    setValues(initValues);
  }

  const handleCalendarChange = () => { /* no-op */}

  const handleCalendarAccept = date => {
    setValues(values => ({
      ...values,
      expirationDate: date
    }));
  }

  const handleGenerateJoinCode = () => {
    Classes.generateJoinCode()
      .then(({ data: code }) => setValues(values => ({ ...values, code })))
      .catch(console.log);
  }

  return (
    <Dialog
      classes={{ paper: clsx(classes.root, className) }}
      fullScreen={fullScreen}
      fullWidth
      maxWidth="sm"
      onClose={onClose}
      open={Boolean(open)}
    >
      <div className={classes.header}>
        <Typography
          variant="h3"
        >
          Create Group
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <div className={classes.inputPadding}>
        <TextField
          autoFocus
          fullWidth
          label="Name"
          margin="dense"
          onChange={handleChange('name')}
          placeholder="Name"
          value={values.name}
          variant="outlined"
        />
      </div>
      <div className={classes.inputPadding}>
        <TextField
          InputProps={{
            endAdornment:
              <Button
                color="secondary"
                onClick={handleGenerateJoinCode}
                variant="contained"
              >
                Generate
              </Button>
          }}
          fullWidth
          label="Group Code"
          margin="normal"
          onChange={handleChange('code')}
          placeholder="Group Code"
          value={values.code}
          variant="outlined"
        />
      </div>
      <div className={classes.inputPadding}>
        <TextField
          fullWidth
          label="Description"
          margin="normal"
          onChange={handleChange('description')}
          placeholder="Description"
          value={values.description}
          variant="outlined"
        />
      </div>
      <div className={classes.actions}>
        <DatePicker
          format="YYYY/MM/DD"
          inputVariant="outlined"
          label="Expiration Date"
          margin="dense"
          minDate={moment()}
          onAccept={handleCalendarAccept}
          onChange={handleCalendarChange}
          value={values.expirationDate}
          variant="dialog"
        />
        <Button
          color="primary"
          endIcon={<GroupAddIcon />}
          onClick={() => onCreateGroup({ ...values, folderID: open }, handleClose)}
          variant="contained"
        >
          Create
        </Button>
      </div>
    </Dialog >
  );
};

Modal.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onCreateGroup: PropTypes.func,
  open: PropTypes.any
};

export default Modal;
